import { render, staticRenderFns } from "./Scripts.vue?vue&type=template&id=9c20db8e&"
import script from "./Scripts.vue?vue&type=script&lang=js&"
export * from "./Scripts.vue?vue&type=script&lang=js&"
import style0 from "./Scripts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports